<form class="routed-component-layout" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" [ngClass]="{ 'ng-touched': form.touched }" *ngIf="form">

  <div class="routed-component-body">
    <div class="routed-component-title-block">
      <h2>{{ "REGISTRATION.BENEFICIAL_OWNER_CHOICE.TITLE" | translate }}</h2>
      <h5>{{ "REGISTRATION.BENEFICIAL_OWNER_CHOICE.DESCRIPTION_1" | translate }}</h5>
      <h5>{{ "REGISTRATION.BENEFICIAL_OWNER_CHOICE.DESCRIPTION_2" | translate }}</h5>
    </div>

    <button data-cy="UBO_Button_WhatIsUBO" type="button" (click)="openUBOHelpDialog()" class="link no-padding">
      {{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.WHAT_IS_UBO' | translate}}
    </button>
    
    <soldo-field-layout
      [control]="form.controls.uboMode"
      fieldName="uboMode"
      cypressSelector="UBO_RadioButton_Mode">

      <fieldset input class="card-group-layout">

        
        <label class="card" data-cy="UBO_RadioButton_EnterNowMode"
          interactive (interact)="enterNowModeRadio.click()">
          <input type="radio" formControlName="uboMode" name="uboMode"
          id="EnterNowMode" [value]="UBOProvisioningChoice.Online" #enterNowModeRadio>
          <h3>{{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_ENTER_NOW.TITLE' | translate}}</h3>
          <p>{{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_ENTER_NOW.DESCRIPTION' | translate}}</p>

        </label>

        
        <label class="card" data-cy="UBO_RadioButton_EmailMode"
          interactive (interact)="emailModeRadio.click()">
          <input type="radio" formControlName="uboMode" name="uboMode"
          id="EmailMode" [value]="UBOProvisioningChoice.Email" #emailModeRadio>
          <h3>{{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_EMAIL.TITLE' | translate}}</h3>
          <p *ngIf="countryOfIncorporation !== 'ITA'">
            {{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_EMAIL.DESCRIPTION' | translate}}
          </p>
          <p *ngIf="countryOfIncorporation === 'ITA'">
            {{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_EMAIL.DESCRIPTION_ITA' | translate}}
          </p>

        </label>

        
        <label class="card" data-cy="UBO_RadioButton_SkipMode"
          interactive (interact)="skipModeRadio.click()">
          <input type="radio" formControlName="uboMode" name="uboMode"
          id="SkipMode" [value]="UBOProvisioningChoice.None" #skipModeRadio>
          <h3>{{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_SKIP.TITLE' | translate}}</h3>
          <p>{{'REGISTRATION.BENEFICIAL_OWNER_CHOICE.MODE_SKIP.DESCRIPTION' | translate}}</p>

        </label>

      </fieldset>

      <ng-container errorMessage>
        <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
      </ng-container>

    </soldo-field-layout>
  </div>
  <div class="navigation-controls-layout">
    <div class="routed-component-cta">

      <button type="button" (click)="goToPrevious()" data-cy="UBO_Button_StepBackButton">
        {{ 'PREVIOUS' | translate }}
      </button>

      <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}"
        data-cy="UBO_Button_StepSubmitButton">
        {{ 'NEXT' | translate}}
      </button>

    </div>
    <save-and-continue-later stepName="Beneficial Owners Choice"></save-and-continue-later>

  </div>
</form>

